import { RegionContentComponent} from './region-content.component';
import { NgModule } from '@angular/core';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';
import { ThemeModule } from '../../@theme/theme.module';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { CountryPicturesComponent } from './country-pictures/country-pictures.component';
import { FormsModule } from '@angular/forms';
import { RegionContentRoutingModule } from './region-content-routing.module';
import { AfriqueComponent } from './region-component/afrique.component';
import { AmeriqueComponent} from './region-component/amerique.component';
import { EuropeComponent } from './region-component/europe.component';
import { AmeriqueCentraleComponent } from './region-component/amerique-centrale.component';
import { OceanPacifiqueComponent } from './region-component/ocean-pacifique.component';
import { OceanIndienComponent } from './region-component/ocean-indien.component';
import { OceanAtlantiqueComponent } from './region-component/ocean-atlantique.component';
import { MoyenOrientComponent } from './region-component/moyen-orient.component';
import { CaraibesComponent } from './region-component/caraibes.component';
import { AsieComponent } from './region-component/asie.component';
import { AmeriqueDuSudComponent } from './region-component/amerique-du-sud.component';
import { AmeriqueDuNordComponent } from './region-component/amerique-du-nord.component';
import { CountryListComponent } from './country-list/country-list.component';


@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbTabsetModule,
    NbActionsModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NgxEchartsModule,
    LeafletModule,
    RegionContentRoutingModule,
  ],
  declarations: [

    CountryPicturesComponent,
    CountryListComponent,
    RegionContentComponent,
    AfriqueComponent,
    AmeriqueComponent,
    AmeriqueCentraleComponent,
    AmeriqueDuNordComponent,
    AmeriqueDuSudComponent,
    AsieComponent,
    CaraibesComponent,
    EuropeComponent,
    MoyenOrientComponent,
    OceanAtlantiqueComponent,
    OceanIndienComponent,
    OceanPacifiqueComponent,
  ],
})
export class RegionContentModule { }
